module.exports = __webpack_public_path__ + "img/pic111.8a5215a9.png";